module.exports = __webpack_public_path__ + "img/image01.3bde4ef2.jpg";